import { baseApiURL } from "../../Utilities/utility";
import axios from "axios";

export function getStdMLFBData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId

        },
        body : JSON.stringify(data),
    };
    return fetch(baseApiURL + "/StandardMLFB/GetStandardMLFB",options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function SearchGetStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId

        },
        body : JSON.stringify(data),
    };
    return fetch(baseApiURL + "/StandardMLFB/GetStandardMLFB",options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function deleteStandarsMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    standardMLFBID
    
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
        body: JSON.stringify(standardMLFBID),
       
    };
    
    return fetch(baseApiURL + "/StandardMLFB/DeleteStandardMLFB?id=" + standardMLFBID , options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getMLFBSeriesList(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/getMLFBSeriesList", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function getDBTypeListBasedOnDbSeries(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    dbSeriesName,
    dbSeriesId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/getDBTypeList?DBSeriesId="+ dbSeriesId +'&dbTypeValue='+ dbSeriesName, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getVariantsList(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/getVariantsList", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getCountriesList(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/getCountriesList", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function getNoOfWaysList1(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    dbSeriesId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/getNoOfWaysList1?DBSeriesId="+ dbSeriesId, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getNoOfWaysList2(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    dbTypeValue) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/getNoOfWaysList2?DBTypeValue="+ dbTypeValue, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function createStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            Gid: gid,
            RoleName: roleName,
            Roleid: roleId,
            userId : userId
            
        },
        body:data,
    };
    return fetch(baseApiURL + "/StandardMLFB/CreateStandardMLFB", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function editStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data


) {
    const options = {
        method: "post",
        headers: {
          
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
            
            
        },
        body:data,
        
    };
    return fetch(baseApiURL + "/StandardMLFB/EditStandardMLFB", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function drawingUpload(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
    ) {
    const options = {
        method: "post",
        headers: {
           Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            RoleName: roleName,
            userId : userId
        },
       
        body: data,
    };
    return fetch(baseApiURL + "/StandardMLFB/UploadDrawing", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function IsMLFBExist(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    let inp = {};

    inp.strMLFB = data;
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId

        },
        body: JSON.stringify(inp),
    };
    return fetch(baseApiURL + "/StandardMLFB/IsMLFBExist?strMLFB=" + data,options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function getPreviewDrawing(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    MLFBId

) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/StandardMLFB/PreviewDrawing?MLFBId=" + MLFBId, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function standardMLFBBulkUpdate(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    formData
    
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
        body: formData,
       
    };
    
    return fetch(baseApiURL + "/StandardMLFB/BulkUpdate", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function ExportStandatdMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    MLFB
) {
    const options = {
        method: "post",
        url: baseApiURL + "/StandardMLFB/ExportStandardMLFB",
        responseType: "arraybuffer",
       
        headers: {
             Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
       data:{ MLFB:MLFB}

    };
    return axios(options)
        .then((response) => {
            return response;
            console.log(response);
        })
        .catch((error) => {
            return error;
        });

}

